

































import { Component, Prop, Vue } from "vue-property-decorator";
import { DateInput } from '@/components/inputs';

@Component({
  components: {
    DateInput,
  }
})
class DateRangeSelector extends Vue {
  @Prop({default: true}) private showWindow!: boolean;
  @Prop() private start: string|null = null;
  @Prop() private end: string|null = null;

  private componentKey = 0;
  private _start: string|null = null;
  private _end: string|null = null;

  constructor() {
    super();
    this._start = this.start;
    this._end = this.end;
  }

  get timeWindowOptions() {
    const now = new Date();
    const day = 24*60*60*1000;
    return [
      {
        id: 'last30Day',
        label: this.$t('general.dateRange.windowOptions.last30Day'),
        dates: () => [
          new Date(now.getTime() - 30*day),
          now
        ]
      },
      {
        id: 'lastMonth',
        label: this.$t('general.dateRange.windowOptions.lastMonth'),
        dates: () => [
          new Date(now.getFullYear(), now.getMonth()-1, 1),
          new Date(now.getFullYear(), now.getMonth(), 0),
        ]
      },
      {
        id: 'last90days',
        label: this.$t('general.dateRange.windowOptions.last90days'),
        dates: () => [
          new Date(now.getTime() - 90*day),
          now
        ]
      },
      {
        id: 'lastQuarter',
        label: this.$t('general.dateRange.windowOptions.lastQuarter'),
        dates: () => [
          new Date(now.getFullYear(), now.getMonth() -4, 1),
          new Date(now.getFullYear(), now.getMonth() -1, 0),
        ]
      },
    ];
  }

  onTimeWindowChange(id: string) {
    if (!id) { return; }
    const match = this.timeWindowOptions.find(item => item.id == id);
    const dates = match!.dates();
    this._start = this.formatDate(dates[0]);
    this._end   = this.formatDate(dates[1]);
    this.onChanged();
    this.componentKey++;
  }

  onStartDateChanged(val: string) {
    this._start = val;
    this.onChanged();
  }

  onEndDateChanged(val: string) {
    this._end = val;
    this.onChanged();
  }

  onChanged() {
    this.$emit('onChanged', this._start, this._end);
  }

  formatDate(date: Date) {
    return new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
      .toISOString()
      .split("T")[0];
  }
}

export default DateRangeSelector;
